module.exports = __webpack_public_path__ + "fonts/icomoon.406d08b.ttf";